/**
 * Full Width Slider Swiper Initialization
 *
 * @global Swiper - Loaded via CDN in full-width-slider.php
 */

document.addEventListener('DOMContentLoaded', function () {
  // Helper function to check and update navigation visibility
  function checkNavigationVisibility(swiper) {
    const navigationElement = document.querySelector(
      '.full-width-slider-navigation'
    );
    if (navigationElement) {
      if (swiper.slides.length <= 1) {
        navigationElement.style.display = 'none';
      } else {
        navigationElement.style.display = 'block';
      }
    }
  }

  // Initialize Swiper for full width slider
  const fullWidthSliderSwiper = new Swiper('.full-width-slider-swiper', {
    // Basic settings
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    // Navigation
    navigation: {
      nextEl: '.full-width-slider-next',
      prevEl: '.full-width-slider-prev',
    },

    // Pagination
    pagination: {
      el: '.full-width-slider-pagination',
      clickable: true,
      bulletActiveClass: 'swiper-pagination-bullet-active',
    },

    // Keyboard control
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    // Accessibility
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },

    // Responsive breakpoints
    breakpoints: {
      // When window width is >= 768px
      768: {
        autoplay: {
          delay: 6000,
        },
      },
    },

    // Callbacks
    on: {
      init: function () {
        // Full width slider swiper initialized
        checkNavigationVisibility(this);
      },
      slidesLengthChange: function () {
        // Called when slides are added or removed
        checkNavigationVisibility(this);
      },
      slideChange: function () {
        // Slide change callback - currently no additional actions needed
        // Future enhancements could include analytics tracking or custom animations
      },
    },
  });

  // Pause autoplay on hover (desktop only)
  if (window.innerWidth > 768) {
    const sliderContainer = document.querySelector('.full-width-slider-swiper');
    if (sliderContainer) {
      sliderContainer.addEventListener('mouseenter', function () {
        fullWidthSliderSwiper.autoplay.stop();
      });

      sliderContainer.addEventListener('mouseleave', function () {
        fullWidthSliderSwiper.autoplay.start();
      });
    }
  }
});
